import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    event: String,
    payload: { type: Object, default: {} },
    delayMs: { type: Number, default: 0 },
  }

  connect() {
    if (window.parent === window) return
    this.posted = false

    if (this.delayMsValue > 0) {
      this.timer = setTimeout(() => this.post(), this.delayMsValue)
      // Flush the pending message if the frame is torn down or navigated away
      // before the timer fires — otherwise a parent-triggered reload within the
      // delay window would clear the timer and drop the event.
      this.onPageHide = () => this.post()
      window.addEventListener('pagehide', this.onPageHide)
    } else {
      this.post()
    }
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    if (this.onPageHide) {
      window.removeEventListener('pagehide', this.onPageHide)
      this.onPageHide = null
    }
    this.post()
  }

  post() {
    if (this.posted) return
    this.posted = true

    window.parent.postMessage(
      { type: this.eventValue, ...this.payloadValue },
      '*',
    )
  }
}
